<template>
    <div>
        <van-field
            readonly
            clickable
            :class="vClass"
            :value="showValue"
            v-bind="fieldOptions"
            @click="onClick(readonly)"
        >
            <div slot="right-icon" class="bh bstart">
                <zb-warning :message="errorMessage" />
                <div class="ico-scanning bg-contain">
                    <div class="scanning-el" @click.stop="onClick(false)"></div>
                </div>
            </div>
        </van-field>
        <van-popup v-model="isShow" position="bottom" @opened="opened">
            <van-picker
                ref="picker"
                show-toolbar
                :columns="data"
                @cancel="onCancel"
                @confirm="onConfirm"
                :value-key="showName"
            />
        </van-popup>
    </div>
</template>
<script>
export default {
    name: "InputSelect",
    model: {
        prop: "value",
        event: "updateValue"
    },
    props: {
        value: null,
        // 文本组件样式
        vClass: null,
        // 错误消息
        errorMessage: null,
        // 点击是否触发外部事件
        readonly: {
            default: true
        },
        // 数据源
        data: {
            default: function() {
                return [];
            }
        },
        // 文本框选项
        fieldOptions: {
            default: function() {
                return {};
            }
        },
        // 显示值字段
        showName: {
            default: "text"
        },
        // 显示值字段
        idName: {
            default: "id"
        }
    },
    data() {
        return {
            // 显示文字
            showValue: null,
            // 选中项
            selectValues: null,
            // 是否显示弹出层
            isShow: false
        };
    },
    computed: {
        // 身份证认证信息
        infoData() {
            return {
                value: this.value,
                data: this.data
            };
        }
    },
    watch: {
        infoData: {
            handler(v) {
                this.setValue(v);
            },
            immediate: true
        }
    },
    methods: {
        // 选择层弹出时
        opened() {
            const me = this;
            if (me.selectValues) {
                me.setValues(this.selectValues);
            }
        },
        // 组件被点击时
        onClick(v) {
            if (!v) {
                // 抛出事件
                this.$emit("click", v);
            } else {
                this.setHidden(false);
            }
        },
        // 显示/隐藏弹出层
        setHidden(v) {
            this.isShow = !v;
        },
        // 点击确定按钮时
        onConfirm(v) {
            const me = this;
            // 隐藏弹出层
            me.setHidden(true);
            // 更新value
            me.$emit("updateValue", v[me.idName]);
            // 抛出事件
            me.$emit("select", v);
        },
        // 点击取消按钮时
        onCancel() {
            this.setValues(this.selectValues);
            // 隐藏弹出层
            this.setHidden(true);
        },
        // 值改变时设置选中值
        setValue({ data, value }) {
            const me = this;
            if (data && data.length) {
                // 查找值
                const selectValues = data.find(rec => {
                    return rec[me.idName] == value;
                });
                if (selectValues) {
                    // 设置实际值
                    me.selectValues = selectValues;
                    // 设置显示值
                    me.showValue = selectValues[me.showName];
                }
            }
        },
        // 设置弹层选中值
        setValues(values) {
            if (values) {
                const me = this,
                    picker = me.$refs.picker;
                // 设置弹层选中值
                picker.setValues([values[me.showName]]);
            }
        }
    }
};
</script>
